import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {of} from 'rxjs';

import { APP_CONFIG, AppConfig } from '../../config/app.config';
import {OutstandingDto} from '../../DTO/outstanding.dto';
import {catchError} from "rxjs/operators";

@Injectable({
  providedIn: 'root',
})
export class OutstandingService {
  private url: string;

  constructor(
    private http: HttpClient,
    @Inject(APP_CONFIG) private appConfig: AppConfig
  ) {
    this.url = `${this.appConfig.apiEndpoint}/outstanding`;
  }
  getOutstandingByCompany(companyId: number) {
    const url = `${this.url}/company/${companyId}/find`;
    return this.http.get<OutstandingDto>(url).pipe(
      catchError(err => {
        if (err.status === 404) {
          return of(null);
        }
        throw err;
      })
    );
  }
}
